<template style="">
  <div class="Game_a_type">
    <div class="yj-view" v-loading="loading">
        <div class="left">
            <!-- <img src="../images/句子图形匹配.png" alt="" width="380" height="230"> -->
        </div>
        <div class="right">
            <h2>{{ info.GameName }}</h2>
            <label>训练描述:</label>
            <p>{{ info.Guideline }}</p>
            <div class="btn-group">
                <div class="btn-left">
                    <button @click="startTest(0)" class="yj-btn">练习</button>
                    <button @click="startTest(1)" class="yj-btn">正式</button>
                </div>
            </div>
        </div>
    </div>

    <el-dialog style="display: none;" :show-close="false" class="bg-black" :fullscreen="true" title="" :visible.sync="dialogVisible">
        <div class="stage" id="stage" ref="stage">
            <!--注释页-->
            <div class="text-center text-white ready-dot" v-if="pageShowStatus === 0">+</div>
            <!--标题-->
            <div v-else-if="pageShowStatus === 1" class="d-flex flex-column justify-content-center text-center text-white" style="height: 100%;">
                <div style="font-size: 30px;">{{ titlesCurrentItem.title }}</div>
            </div>
            <!--游戏-->
            <div v-else-if="pageShowStatus === 2" class="d-flex flex-column justify-content-center text-center" style="height: 100%;">
              <div class="btn_this btn_ok" @click="gotoOk(1)">是</div>
              <div class="d-flex flex-column imgbox text-white" style="align-self:baseline;">
                  <span style="font-size: 35px;" class="pb-5" :class="testTopicCurrentItem.status === 0 ? testTopicCurrentItem.star : testTopicCurrentItem.plus"></span>
                  <span style="font-size: 30px;" class="" :class="testTopicCurrentItem.status === 0 ? testTopicCurrentItem.plus : testTopicCurrentItem.star"></span>
              </div>
              <div class="btn_this btn_no" @click="gotoOk(0)">否</div>
            </div>
            <!--结果-->
            <div v-else style="font-size: 30px;height: 100%;" class="d-flex flex-column justify-content-center text-center text-white">
              <div v-if="pageFeedbackStatus === 1">
                <p>您本次实验的平均反应时为：{{ correctAverageTime }}ms</p>
                <p style="font-size: 20px;">谢谢您的参与！</p>
              </div>
            </div>
        </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  data() {
    return {
      timer: null,
      setIntervalTime: 3, //呈现时间(秒)
      testStatus: 0, // 测试状态 0:测试 1:正式
      pageShowStatus: 0, //页面内容显示状态 0:注释点 1:游戏标题页 2:游戏页 3:结果
      pageFeedbackStatus: 0, //反馈空屏状态 0:空屏 1不是空屏
      onKeyStatus: true, //按键状态 true:可按 false:不可按
      responderStatus: true, //答题状态 true:抢答 false:正常答题
      responderRecord: false, //抢答记录
      isKey: 0, //是否按键 0:没按 1:按
      practiceCount: 0, //练习测试次数
      officialCount: 0, //正式测试次数
      correctAverageTime: 0, //正确平均反应时(平均反应时只计算正确的，错误与抢答的不做记录)
      recordPracticeNum: 0, //练习页面数 用于判断是否到反馈页，如果到了反馈页后从注释点页面继续开始呈现页面
      startTime: 0, //开始时间戳
      endTime: 0, //结束时间戳
      reportID: "", //游戏编号
      publishID: "", //发布编号
      startTimeDate: '', //开始日期时间
      endTimeDate: '', //结束日期时间
      randomTitlesIndex: 0, //测试标题随机下标
      titlesCurrentItem: {}, //当前标题对象
      titlesUpList: [], //上一组标题列表
      testTopicIndex: 0, // 测试图形随机下标
      testTopicCurrentItem: {}, //当前图形
      testTopicUpList: [], //上一组标题列表
      titlesList: [], //标题赋值
      testTopicList: [], //图形赋值
      result: [], //结果
      dialogVisible:false,
      info:{GameName:"句子-图形匹配",Guideline:"欢迎您参加本次实验，这是一个句子和图形匹配的实验。你会在屏幕上看到1个句子，接着屏幕会呈现一幅图。该图形包含一个【☆】和一个【+】字。你需要做出句子描述和图形是否一致的判断，【是】按f键，【否】按j键。请将左手食指悬放在f键上方，右手食指悬放在j键上方。每一次结束后请立即准备下一次反应。抢答按错误记录。",ResultID1:null,TestNum1:5,TestNum2:32,Url1:"http://172.16.0.110:8003",Url2:"http://172.16.0.110:9004"},
      /*
      * 测试题
      * status: 图形状态 (0星号在十字上方 1星号在十字下方)
      * title: 测试标题
      */
      titles: [
        { title: '星号在十字上面', status: 0 },
        { title: '星号在十字下面', status: 1 },
        { title: '星号不在十字上面', status: 1 },
        { title: '星号不在十字下面', status: 0 },
        { title: '十字在星号上面', status: 1 },
        { title: '十字在星号下面', status: 0 },
        { title: '十字不在星号上面', status: 0 },
        { title: '十字不在星号下面', status: 1 },
        { title: '星号在十字上面', status: 0 },
        { title: '星号在十字下面', status: 1 },
        { title: '星号不在十字上面', status: 1 },
        { title: '星号不在十字下面', status: 0 },
        { title: '十字在星号上面', status: 1 },
        { title: '十字在星号下面', status: 0 },
        { title: '十字不在星号上面', status: 0 },
        { title: '十字不在星号下面', status: 1 },
      ],
      testTopic: [
        { status: 0, describe: '星在上,加在下', star: 'el-icon-star-off', plus:'el-icon-plus'},
        { status: 1, describe: '星在下,加在上', star: 'el-icon-star-off', plus:'el-icon-plus'},
        { status: 1, describe: '星在下,加在上', star: 'el-icon-star-off', plus:'el-icon-plus'},
        { status: 0, describe: '星在上,加在下', star: 'el-icon-star-off', plus:'el-icon-plus'},
        { status: 1, describe: '星在下,加在上', star: 'el-icon-star-off', plus:'el-icon-plus'},
        { status: 0, describe: '星在上,加在下', star: 'el-icon-star-off', plus:'el-icon-plus'},
        { status: 0, describe: '星在上,加在下', star: 'el-icon-star-off', plus:'el-icon-plus'},
        { status: 1, describe: '星在下,加在上', star: 'el-icon-star-off', plus:'el-icon-plus'},
        { status: 0, describe: '星在上,加在下', star: 'el-icon-star-off', plus:'el-icon-plus'},
        { status: 1, describe: '星在下,加在上', star: 'el-icon-star-off', plus:'el-icon-plus'},
        { status: 1, describe: '星在下,加在上', star: 'el-icon-star-off', plus:'el-icon-plus'},
        { status: 0, describe: '星在上,加在下', star: 'el-icon-star-off', plus:'el-icon-plus'},
        { status: 1, describe: '星在下,加在上', star: 'el-icon-star-off', plus:'el-icon-plus'},
        { status: 0, describe: '星在上,加在下', star: 'el-icon-star-off', plus:'el-icon-plus'},
        { status: 0, describe: '星在上,加在下', star: 'el-icon-star-off', plus:'el-icon-plus'},
        { status: 1, describe: '星在下,加在上', star: 'el-icon-star-off', plus:'el-icon-plus'},
      ],
    }
  },
  created() {
    this.getApi();
  },
  methods: {
    mySignOutGame(){
      if (!!window.android) window.android.getTitle("");
      location.reload()
    },
    rand(min, max) {
      return Math.round(Math.random() * (max - min) + min);
    },
    formatDate(date) {
      var date = new Date(date);
      var YY = date.getFullYear() + '-';
      var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
      var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
      var fff = date.getMilliseconds() >= 100 ? date.getMilliseconds() : date.getMilliseconds() >= 10 ? '0' + date.getMilliseconds() : '00' + date.getMilliseconds();
      return YY + MM + DD + " " + hh + mm + ss;
    },
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //
      var r = window.location.search.substr(1).match(reg); //
      if (r != null) return decodeURIComponent(r[2]);
      return null; //
    },
    // 获取初始数据
    getApi() {
      this.loading = false;
      this.practiceCount = 5;
      this.officialCount = 32;
      this.reportID = this.getUrlParam('UserID');//游戏编号
      this.publishID = this.getUrlParam('PublishID');//发布编号
    },
    // 正式测试
    startTest(status) {
      this.dialogVisible = true;
      this.testStatus = status;
      if (status === 0) this.commentsPoint();//练习
      if (status === 1) {
        this.pageShowStatus = 1;
        this.onKeyStatus = true;
        this.responderStatus = false;
        this.gameFun();
      }//正式
      this.onKeyFun();
    },
    //注视点界面消失
    commentsPoint() {
      let that = this;
      that.onKeyStatus = true;
      that.responderStatus = true;
      that.startTime = new Date().getTime();
      that.startTimeDate = this.formatDate(this.startTime);
      setTimeout(function () {
        that.pageShowStatus = 1;
        that.recordPracticeNum += 1;
        that.responderStatus = false;
        that.gameFun();
      }, 1000)
    },
    //测试游戏控制器逻辑函数
    gameSetIntervalFun() {
      let time = this.setIntervalTime; //图形呈现秒数
      this.gameFun();
      if (this.testStatus === 0 && this.responderRecord) {
        this.gamePublicFun();
        return false;
      }
      this.timer = setInterval(() => {
        time--;
        if (time === 0) {
          this.gamePublicFun();
        }
      }, 1000);
    },
    //游戏函数
    gameFun() {
      let that = this;
      //判断是标题还是图形界面
      if (this.pageShowStatus === 1) {
        this.onKeyStatus = false;
        this.randomTitlesIndex = this.rand(0, this.titles.length - 1);
        this.titlesCurrentItem = this.titles[this.randomTitlesIndex];
        this.titlesUpList.push(this.titlesCurrentItem);
        this.titles.splice(this.randomTitlesIndex, 1);
        setTimeout(() => {
          that.pageShowStatus = 2;
          that.recordPracticeNum += 1;
          that.gameSetIntervalFun();
        }, 1000);
        return false
      }

      if (this.responderRecord === false && this.pageShowStatus !== 1) {
        this.onKeyStatus = true;
      }

      if (this.pageShowStatus === 2) {
        this.startTime = new Date().getTime();
        this.startTimeDate = this.formatDate(this.startTime);
        this.testTopicIndex = this.rand(0, this.testTopic.length - 1);
        this.testTopicCurrentItem = this.testTopic[this.testTopicIndex];
        this.testTopicUpList.push(this.testTopicCurrentItem);
        this.testTopic.splice(this.testTopicIndex, 1);
      }
    },

    //游戏共用函数
    gamePublicFun() {
      let that = this;
      that.onKeyStatus = false;
      that.responderRecord = false;
      that.recordPracticeNum += 1;
      //练习测试与正式测试测试次数
      if (that.testStatus === 0) that.practiceCount--;
      if (that.testStatus === 1) that.officialCount--;
      //判断正式是否按键
      if (that.testStatus === 1 && that.isKey === 0) that.leaveOutFun();
      if (that.testStatus === 1 && that.isKey === 1) that.isKey = 0;
      //判断图形如果完成了1轮16次后，切换下一轮、初始化数据,正式一共2轮32次
      if (that.titlesUpList.length === 16 && that.testTopicUpList.length === 16) {
        that.titlesList = that.titlesUpList;
        that.titles = that.titlesList;
        that.titlesUpList = [];
        that.testTopicList = that.testTopicUpList;
        that.testTopic = that.testTopicList;
        that.testTopicUpList = [];
      }

      //判断如果是练习并且练习页面数2时，从注释点页面开始呈现页面
      if (that.testStatus === 0 && that.recordPracticeNum === 3 && that.practiceCount >= 0) {
        clearInterval(that.timer);
        //判断是否按键
        if (that.isKey === 0) {that.leaveOutFun();}
        const resultHtml = that.result[that.result.length - 1].Result === '正确' ? '<span style="color: blue;">' + that.result[that.result.length - 1].Result + '</span>' : '<span style="color: red;">' + that.result[that.result.length - 1].Result + '</span>';
        const reactionTimeHtml = that.result[that.result.length - 1].ReactionTime !== 0 ? '<br/><p>' + '反应时为：' + that.result[that.result.length - 1].ReactionTime + 'ms' + '</p>' : '';
        let endTile = '本次结果';
        if (that.practiceCount === 0) endTile += '(练习结束)';
        that.$alert('本次反应结果为：' + resultHtml + ' !' + reactionTimeHtml, endTile, {confirmButtonText: '确定',dangerouslyUseHTMLString: true,callback: action => {
            if (that.practiceCount !== 0) {
              that.recordPracticeNum = 0;
              that.pageShowStatus = 0;
              that.result = [];
              that.isKey = 0;
              that.commentsPoint();
            } else {
              this.mySignOutGame();
            }
          }
        });
        return false;
      }

      //正式练习次数达到后结束游戏
      if (that.testStatus === 1 && that.officialCount === 0) {
        clearInterval(that.timer);
        that.resultFun();
        that.submitData();
      } else {
        clearInterval(that.timer);
        that.pageShowStatus = 1;
        that.onKeyStatus = true;
        that.responderStatus = false;
        that.gameFun();
        // time = that.setIntervalTime;
      }
    },
    //遗漏
    leaveOutFun() {
      let obj = {};
      this.endTime = new Date().getTime();
      obj.GameID = 'YJ-14';//游戏编号
      obj.ReportID = this.reportID;//报告编号
      obj.PublishID = this.publishID;//发布编号
      obj.StartTime = this.startTimeDate;//开始时间
      obj.No1 = this.result.length + 1;//序号
      obj.Sentence = this.titlesUpList[this.titlesUpList.length - 1].title; //刺激句子
      obj.ImgDesc = this.testTopicUpList[this.testTopicUpList.length - 1].describe; //图片（文字描述）
      obj.ImgRelation = this.titlesUpList[this.titlesUpList.length - 1].status === this.testTopicUpList[this.testTopicUpList.length - 1].status ? '肯定匹配' : '肯定不匹配';//图片关系
      obj.ReactionTime = 0;//反应时（毫秒）
      obj.EndTime = this.formatDate(this.endTime);//结束时间
      obj.Result = '未反应';//结果
      if (this.result.length + 1 == 1) {
        obj.ReportID = obj.ReportID + "_" + this.PublishID;
      }
      this.result.push(obj);
    },
    gotoOk: function (state) {
      if (this.onKeyStatus) {
        this.onKeyStatus = false;
        this.isKey = 1;
        let obj = {};
        this.endTime = new Date().getTime();
        //抢答
        if (this.responderStatus) {
          this.responderRecord = true;
          obj.Result = '错误';
          obj.ReactionTime = 0;
          this.result.push(obj);
          return false;
        }
        //正常答题
        obj.GameID = 'YJ-14';//游戏编号
        obj.ReportID = this.reportID;//报告编号
        obj.PublishID = this.publishID;//发布编号
        obj.StartTime = this.startTimeDate;//开始时间
        obj.No1 = this.result.length + 1;//序号
        obj.Sentence = this.titlesUpList[this.titlesUpList.length - 1].title;//刺激句子
        obj.ImgDesc = this.testTopicUpList[this.testTopicUpList.length - 1].describe;//图片（文字描述）
        obj.ImgRelation = this.titlesUpList[this.titlesUpList.length - 1].status === this.testTopicUpList[this.testTopicUpList.length - 1].status ? '肯定匹配' : '肯定不匹配';//图片关系
        obj.EndTime = this.formatDate(this.endTime);//结束时间
        if (this.responderStatus === false) {
          const result = (state === 1 && this.titlesUpList[this.titlesUpList.length - 1].status === this.testTopicUpList[this.testTopicUpList.length - 1].status) ? '正确' : (state === 0 && this.titlesUpList[this.titlesUpList.length - 1].status !== this.testTopicUpList[this.testTopicUpList.length - 1].status) ? '正确' : '错误';
          obj.Result = result;
          obj.ReactionTime = result === '正确' ? this.endTime - this.startTime : 0;
          this.result.push(obj);
        }
        //正常答题后,切换下一提
        clearInterval(this.timer);
        this.gamePublicFun();
      }
    },

    /** 监听键盘*  f:是 j:否*/
    onKeyFun(){
      let that = this;
      document.onkeyup = function (e) {
        let el = e || event || window.event || arguments.callee.caller.arguments[0];
        if ((el.key === 'f' && that.onKeyStatus) || (el.key === 'j' && that.onKeyStatus)) {
          that.onKeyStatus = false;
          that.isKey = 1;
          let obj = {};
          that.endTime = new Date().getTime();

          //抢答
          if (that.responderStatus) {
            that.responderRecord = true;
            obj.Result = '错误';
            obj.ReactionTime = 0;
            that.result.push(obj);
            return false;
          }

          //正常答题
          obj.GameID = 'YJ-14';//游戏编号
          obj.ReportID = that.reportID;//报告编号
          obj.PublishID = that.publishID;//发布编号
          obj.StartTime = that.startTimeDate;//开始时间
          obj.No1 = that.result.length + 1;//序号
          obj.Sentence = that.titlesUpList[that.titlesUpList.length - 1].title;//刺激句子
          obj.ImgDesc = that.testTopicUpList[that.testTopicUpList.length - 1].describe;//图片（文字描述）
          obj.ImgRelation = that.titlesUpList[that.titlesUpList.length - 1].status === that.testTopicUpList[that.testTopicUpList.length - 1].status ? '肯定匹配' : '肯定不匹配';//图片关系
          obj.EndTime = this.formatDate(that.endTime);//结束时间
          if (that.responderStatus === false) {
            const result = (el.key === 'f' && that.titlesUpList[that.titlesUpList.length - 1].status === that.testTopicUpList[that.testTopicUpList.length - 1].status) ? '正确' : (el.key === 'j' && that.titlesUpList[that.titlesUpList.length - 1].status !== that.testTopicUpList[that.testTopicUpList.length - 1].status) ? '正确' : '错误';
            obj.Result = result;
            obj.ReactionTime = result === '正确' ? that.endTime - that.startTime : 0;
            that.result.push(obj);
          }

          //正常答题后,切换下一提
          clearInterval(that.timer);
          that.gamePublicFun();
        }
      };
    },
    
    //结果 (计算正反平均反应时)
    resultFun() {
      let correctAverageTime = 0;//正确字反应时
      let correctAverageNum = 0;//正确个数
      for (let i = 0; i < this.result.length; i++) {//正的平均反应时
        if (this.result[i].Result === '正确') {
          correctAverageTime += this.result[i].ReactionTime;
          correctAverageNum += 1;
        }
      }
      
      this.correctAverageTime = correctAverageTime / correctAverageNum > 0 ? (correctAverageTime / correctAverageNum).toFixed(2) : 0;
    },

    //数据保存
    submitData(){
      //重组图形匹配关系字段,(Sentence字段)句子描述带不的并且(ImgRelation)图形关系为肯定匹配的为否定匹配、否则肯定不匹配为否定不匹配
      for (let i = 0; i < this.result.length; i++) {
        let sentenceIndexResult = this.result[i].Sentence.indexOf('不');
        let imgRelation = this.result[i].ImgRelation;
        if (this.result[i].Result === '未反应') this.result[i].Result = '未反应';
        if (sentenceIndexResult !== -1 && imgRelation === '肯定匹配') this.result[i].ImgRelation = '否定匹配';
        if (sentenceIndexResult !== -1 && imgRelation === '肯定不匹配') this.result[i].ImgRelation = '否定不匹配';
      }
    }

  },
  mounted() {

  },
  computed: {

  },
}

</script>

<style>
  .Game_a_type{width: 100%;height: 100%;position: relative;}
  .imgbox{border: 1px solid #fff;margin: 0 auto;padding: 20px 10px;}
  .el-dialog.is-fullscreen{background-color: #000000;}
  .btn_this{width: 120px;height: 40px;line-height: 40px;background: linear-gradient( 270deg, rgba(34, 137, 240, 1) 0%, rgba(59, 208, 244, 1) 100%);box-shadow: 0px 2px 4px rgb(113 157 255);opacity: 1;border-radius: 20px;border: 0px;color: #ffffff;font-size: 16px;cursor: pointer;outline: none;}
  .btn_ok{position: absolute;left: 20%;}
  .btn_no{position: absolute;right: 20%; border-radius: 5px;}

</style>
